import { render } from "./ordentrabajoresultadopoliza.vue?vue&type=template&id=665094ab&scoped=true"
import script from "./ordentrabajoresultadopoliza.vue?vue&type=script&lang=js"
export * from "./ordentrabajoresultadopoliza.vue?vue&type=script&lang=js"

import "./ordentrabajoresultadopoliza.vue?vue&type=style&index=0&id=665094ab&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665094ab"]])

export default __exports__